import React from "react";

import { Body } from "src/components/typography/typography";

/*
 * Constants
 */

export const ADMINISTRATOR_ROLES = [
    "Superintendent",
    "Assistant Superintendent",
    "Head of School / Headmaster",
    "Head Principal",
    "Assistant Principal",
    "Instructional Director",
    "Business / Operations Director",
    "Admissions Director",
    "Athletic Director",
    "Special Services Director",
    "Curriculum Specialist",
    "Development / Advancement",
];

export const SUPPORT_STAFF_ROLES = [
    "Athletic Director",
    "Business Manager",
    "Child Nutrition (Cafeteria)",
    "Classroom Aide",
    "Coach",
    "Counselor",
    "Curriculum Specialist",
    "Custodian",
    "Development / Advancement",
    "Librarian",
    "Office Assistant",
    "Psychologist",
    "Receptionist",
    "Special Education",
    "Therapist (Occupational / Speech)",
    "Technology Coordinator",
];

// A role on both lists is starred, so the star always means what the note under it says.
const SHARED_ROLES = new Set(ADMINISTRATOR_ROLES.filter((role) => SUPPORT_STAFF_ROLES.includes(role)));

/*
 * Components
 */

const RoleList = ({ roles }: { readonly roles: string[] }): React.ReactElement => (
    <ul className="constituent-role-list">
        {roles.map((role) => (
            <li key={role}>{SHARED_ROLES.has(role) ? `${role} *` : role}</li>
        ))}
    </ul>
);

const SharedRoleNote = (): React.ReactElement => (
    <Body>
        * Roles that appear on both the Administrator and Support Staff Constituent Groups. Choose one group for this
        role. A simple rule: if the person supervises other staff or serves on the school&apos;s leadership team, send
        the Administrator Survey; otherwise, send the Support Staff Survey.
    </Body>
);

export const AdministratorsHelp = (): React.ReactElement => (
    <>
        <Body>
            Enter the TOTAL number of individuals employed in administration. This may include any of the following:
        </Body>
        <RoleList roles={ADMINISTRATOR_ROLES} />
        <SharedRoleNote />
    </>
);

export const SupportStaffHelp = (): React.ReactElement => (
    <>
        <Body>Enter the TOTAL number of staff members. This may include any of the following:</Body>
        <RoleList roles={SUPPORT_STAFF_ROLES} />
        <SharedRoleNote />
    </>
);
